import { PollFields, MutationFunctions } from '../../types/fields.generated.js'
import {
  MutationCastVoteArgs,
  MutationCreatePollArgs,
  MutationUpdatePollArgs,
  Poll,
} from '../../types/index.js'
import { GraphqlClient } from '../graphql.client.js'

export class PollsClient {
  private client: GraphqlClient

  constructor(client: GraphqlClient) {
    this.client = client
  }

  async create(
    variables: MutationCreatePollArgs,
    fields: PollFields = 'basic',
    accessToken: string = undefined,
  ): Promise<Poll> {
    type QueryResult = { createPoll: Poll }
    const result = await this.client.authorizedRequest<QueryResult>({
      query: MutationFunctions.createPoll(fields),
      variables,
      customToken: accessToken,
    })
    return result.createPoll
  }

  async update(
    variables: MutationUpdatePollArgs,
    fields: PollFields = 'basic',
    accessToken: string = undefined,
  ): Promise<Poll> {
    type QueryResult = { updatePoll: Poll }
    const result = await this.client.authorizedRequest<QueryResult>({
      query: MutationFunctions.updatePoll(fields),
      variables,
      customToken: accessToken,
    })
    return result.updatePoll
  }

  async castVote(
    variables: MutationCastVoteArgs,
    fields: PollFields = 'basic',
    accessToken: string = undefined,
  ): Promise<Poll> {
    type QueryResult = { castVote: Poll }
    const result = await this.client.authorizedRequest<QueryResult>({
      query: MutationFunctions.castVote(fields),
      variables,
      customToken: accessToken,
    })
    return result.castVote
  }
}
